'use client';

import { useSyncExternalStore } from 'react';

const COARSE_POINTER = '(pointer: coarse)';

function subscribe(onChange: () => void) {
    const query = window.matchMedia(COARSE_POINTER);
    query.addEventListener('change', onChange);

    return () => query.removeEventListener('change', onChange);
}

function getSnapshot() {
    return window.matchMedia(COARSE_POINTER).matches;
}

/** A touch screen as the primary pointer. The server renders the calendar
 *  variant; a touch device switches to its native picker after hydration. */
export function useCoarsePointer(): boolean {
    return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
